import React, { useState } from 'react'
import Mainlayout from '../layout/Mainlayout'
import Teams from '../data/teams.json'
import Gamess from '../data/games.json'
import { GrClose } from "react-icons/gr";
import { Link } from 'react-router-dom';

export default function Games() {
    const [grop, setGrop] = useState(null)

    function groupa() {
        return (
            <div className='md:w-[83%] mx-auto bg-yakam p-1 md:p-4 rounded-xl'>
                <div className='flex justify-between'>
                    <h1 className=' text-chwaram w-[100%]  text-center  text-3xl  drop-shadow-lg'>A یارییەکانی گروپی</h1>
                    <div className=' items-center justify-center'>
                        <button className=' items-center justify-center' >
                            <GrClose onClick={() => setGrop(null)} className='w-5 h-5 p-px rounded-full bg-red-300 mx-auto ' />
                        </button>
                    </div>
                </div>
                <div className="w-full  overflow-x-auto my-2   rounded-lg">


                    {Gamess.map((team, index) => {
                        if (team.group === 'Group A') {

                            return (

                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full  p-1 md:p-3 mx-auto'>
                                    <div className='space-y-3 mx-auto text-chwaram'>

                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                        <div className='flex flex-row space-x-4 mx-auto'>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>
                                                {team.result === "" ?
                                                    (
                                                        <>

                                                            {team.time}
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>

                                                            {team.result}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                        </div>

                                    </div>
                                </div>
                            )
                        }
                        else {
                            return (
                                null
                            )
                        }
                    })

                    }

                </div>
            </div>
        )
    }
    function groupb() {
        return (
            <div className='md:w-[83%] mx-auto bg-yakam p-1 md:p-4 rounded-xl'>
                <div className='flex justify-between'>
                    <h1 className=' text-chwaram w-[100%]  text-center  text-3xl  drop-shadow-lg'>B یارییەکانی گروپی</h1>
                    <div className=' items-center justify-center'>
                        <button className=' items-center justify-center' >
                            <GrClose onClick={() => setGrop(null)} className='w-5 h-5  mx-auto text-white p-px rounded-full bg-red-300' />
                        </button>
                    </div>
                </div>
                <div className="w-full  overflow-x-auto my-2   rounded-lg">


                    {Gamess.map((team, index) => {
                        if (team.group === 'Group B') {

                            return (

                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full  p-1 md:p-3 mx-auto'>
                                    <div className='space-y-3 mx-auto text-chwaram'>

                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                        <div className='flex flex-row space-x-4 mx-auto'>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>
                                                {team.result === "" ?
                                                    (
                                                        <>

                                                            {team.time}
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>

                                                            {team.result}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                        </div>

                                    </div>
                                </div>
                            )
                        }
                        else {
                            return (
                                null
                            )
                        }
                    })

                    }

                </div>
            </div>
        )
    }
    function groupc() {
        return (
            <div className='md:w-[83%] mx-auto bg-yakam p-1 md:p-4 rounded-xl'>
                <div className='flex justify-between'>
                    <h1 className=' text-chwaram w-[100%]  text-center  text-3xl  drop-shadow-lg'>C یارییەکانی گروپی</h1>
                    <div className=' items-center justify-center'>
                        <button className=' items-center justify-center' >
                            <GrClose onClick={() => setGrop(null)} className='w-5 h-5  mx-auto text-white p-px rounded-full bg-red-300' />
                        </button>
                    </div>
                </div>
                <div className="w-full  overflow-x-auto my-2   rounded-lg">


                    {Gamess.map((team, index) => {
                        if (team.group === 'Group C') {

                            return (

                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full  p-1 md:p-3 mx-auto'>
                                    <div className='space-y-3 mx-auto text-chwaram'>

                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                        <div className='flex flex-row space-x-4 mx-auto'>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>
                                                {team.result === "" ?
                                                    (
                                                        <>

                                                            {team.time}
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>

                                                            {team.result}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                        </div>

                                    </div>
                                </div>
                            )
                        }
                        else {
                            return (
                                null
                            )
                        }
                    })

                    }

                </div>
            </div>
        )
    }
    function groupd() {
        return (
            <div className='md:w-[83%] mx-auto bg-yakam p-1 md:p-4 rounded-xl'>
                <div className='flex justify-between'>
                    <h1 className=' text-chwaram w-[100%]  text-center  text-3xl  drop-shadow-lg'>D یارییەکانی گروپی</h1>
                    <div className=' items-center justify-center'>
                        <button className=' items-center justify-center' >
                            <GrClose onClick={() => setGrop(null)} className='w-5 h-5  mx-auto text-white p-px rounded-full bg-red-300' />
                        </button>
                    </div>
                </div>
                <div className="w-full  overflow-x-auto my-2   rounded-lg">


                    {Gamess.map((team, index) => {
                        if (team.group === 'Group D') {

                            return (

                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full  p-1 md:p-3 mx-auto'>
                                    <div className='space-y-3 mx-auto text-chwaram'>

                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                        <div className='flex flex-row space-x-4 mx-auto'>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>
                                                {team.result === "" ?
                                                    (
                                                        <>

                                                            {team.time}
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>

                                                            {team.result}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                        </div>

                                    </div>
                                </div>
                            )
                        }
                        else {
                            return (
                                null
                            )
                        }
                    })

                    }

                </div>
            </div>
        )
    }
    function groupe() {
        return (
            <div className='md:w-[83%] mx-auto bg-yakam p-1 md:p-4 rounded-xl'>
                <div className='flex justify-between'>
                    <h1 className=' text-chwaram w-[100%]  text-center  text-3xl  drop-shadow-lg'>E یارییەکانی گروپی</h1>
                    <div className=' items-center justify-center'>
                        <button className=' items-center justify-center' >
                            <GrClose onClick={() => setGrop(null)} className='w-5 h-5  mx-auto text-white p-px rounded-full bg-red-300' />
                        </button>
                    </div>
                </div>
                <div className="w-full  overflow-x-auto my-2   rounded-lg">


                    {Gamess.map((team, index) => {
                        if (team.group === 'Group E') {

                            return (

                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full  p-1 md:p-3 mx-auto'>
                                    <div className='space-y-3 mx-auto text-chwaram'>

                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                        <div className='flex flex-row space-x-4 mx-auto'>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>
                                                {team.result === "" ?
                                                    (
                                                        <>

                                                            {team.time}
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>

                                                            {team.result}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                        </div>

                                    </div>
                                </div>
                            )
                        }
                        else {
                            return (
                                null
                            )
                        }
                    })

                    }

                </div>
            </div>
        )
    }
    function groupf() {
        return (
            <div className='md:w-[83%] mx-auto bg-yakam p-1 md:p-4 rounded-xl'>
                <div className='flex justify-between'>
                    <h1 className=' text-chwaram w-[100%]  text-center  text-3xl  drop-shadow-lg'>F یارییەکانی گروپی</h1>
                    <div className=' items-center justify-center'>
                        <button className=' items-center justify-center' >
                            <GrClose onClick={() => setGrop(null)} className='w-5 h-5  mx-auto text-white p-px rounded-full bg-red-300' />
                        </button>
                    </div>
                </div>
                <div className="w-full  overflow-x-auto my-2   rounded-lg">


                    {Gamess.map((team, index) => {
                        if (team.group === 'Group F') {

                            return (

                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full  p-1 md:p-3 mx-auto'>
                                    <div className='space-y-3 mx-auto text-chwaram'>

                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                        <div className='flex flex-row space-x-4 mx-auto'>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>
                                                {team.result === "" ?
                                                    (
                                                        <>

                                                            {team.time}
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>

                                                            {team.result}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                        </div>

                                    </div>
                                </div>
                            )
                        }
                        else {
                            return (
                                null
                            )
                        }
                    })

                    }

                </div>
            </div>
        )
    }
    function groupg() {
        return (
            <div className='md:w-[83%] mx-auto bg-yakam p-1 md:p-4 rounded-xl'>
                <div className='flex justify-between'>
                    <h1 className=' text-chwaram w-[100%]  text-center  text-3xl  drop-shadow-lg'>G یارییەکانی گروپی</h1>
                    <div className=' items-center justify-center'>
                        <button className=' items-center justify-center' >
                            <GrClose onClick={() => setGrop(null)} className='w-5 h-5  mx-auto text-white p-px rounded-full bg-red-300' />
                        </button>
                    </div>
                </div>
                <div className="w-full  overflow-x-auto my-2   rounded-lg">


                    {Gamess.map((team, index) => {
                        if (team.group === 'Group G') {

                            return (

                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full  p-1 md:p-3 mx-auto'>
                                    <div className='space-y-3 mx-auto text-chwaram'>

                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                        <div className='flex flex-row space-x-4 mx-auto'>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>
                                                {team.result === "" ?
                                                    (
                                                        <>

                                                            {team.time}
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>

                                                            {team.result}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                        </div>

                                    </div>
                                </div>
                            )
                        }
                        else {
                            return (
                                null
                            )
                        }
                    })

                    }
                </div>
            </div>
        )
    }
    function grouph() {
        return (
            <div className='md:w-[83%] mx-auto bg-yakam p-1 md:p-4 rounded-xl'>
                <div className='flex justify-between'>
                    <h1 className=' text-chwaram w-[100%]  text-center  text-3xl  drop-shadow-lg'>H یارییەکانی گروپی</h1>
                    <div className=' items-center justify-center'>
                        <button className=' items-center justify-center' >
                            <GrClose onClick={() => setGrop(null)} className='w-5 h-5  mx-auto text-white p-px rounded-full bg-red-300' />
                        </button>
                    </div>
                </div>
                <div className="w-full  overflow-x-auto my-2   rounded-lg">


                    {Gamess.map((team, index) => {
                        if (team.group === 'Group H') {

                            return (

                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full  p-1 md:p-3 mx-auto'>
                                    <div className='space-y-3 mx-auto text-chwaram'>

                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                        <div className='flex flex-row space-x-4 mx-auto'>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>
                                                {team.result === "" ?
                                                    (
                                                        <>

                                                            {team.time}
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>

                                                            {team.result}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-2 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                        </div>

                                    </div>
                                </div>
                            )
                        }
                        else {
                            return (
                                null
                            )
                        }
                    })

                    }

                </div>
            </div>
        )
    }

    const [warnning, setWarnning] = useState(
        <div id="alert-1" class="flex p-4  bg-blue-100 " role="alert">
            <svg aria-hidden="true" class="flex-shrink-0 w-5 h-5 text-blue-700 " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
            <span class="sr-only">Info</span>
            <div class="ml-3 text-center text-sm font-medium text-blue-700 ">
                دەتوانی لێرە ئەنجامی یارییەکان و خشتەی یاریەکان ببینیت
            </div>
            <button onClick={()=>{setWarnning(null)}} type="button" class="ml-auto -mx-1.5 -my-1.5 bg-blue-100 text-blue-500 rounded-lg focus:ring-2 focus:ring-blue-400 p-1.5 hover:bg-blue-200 inline-flex h-8 w-8" data-dismiss-target="#alert-1" aria-label="Close">
                <span class="sr-only">Close</span>
                <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
            </button>
        </div>
    )

    return (
        <Mainlayout>
            <p className='text-3xl bg-dwam text-center p-4 text-shasham '><Link to='/peshbinikrdn' className='hover:text-chwaram'>پێشبی بکە بۆ یارییەکانی ئەمڕۆ</Link></p>
            {warnning}
            <div className='bg-dwam min-h-screen p-1 md:p-10 flex flex-col-reverse md:flex-row-reverse justify-between md:items-start items-center'>

                <div className="my-4   md:my-0 w-full md:w-fit h-96 overflow-x-auto  rounded-lg">
                    <h1 className='bg-yakam text-center border-b-2 rounded-t-lg border-chwaram p-1 text-xl md:text-xl text-chwaram'>وڵاتە بەشداربووەکان</h1>
                    <table className=" text-center rounded-lg w-full relative text-xs text-black bg-slate-100 ">
                        <thead className="md:text-lg text-xs text-chwaram uppercase bg-yakam ">
                            <tr>

                                <th scope="col" className="px-6 py-3">
                                    لۆگۆ
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    گروپ
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    یانە
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    ID
                                </th>


                            </tr>
                        </thead>
                        <tbody>

                            {Teams.map((team) => {
                                return (

                                    <tr className="bg-dwam divide-y-2 md:text-md text-xs divide-yakam text-shasham border-black">
                                        <td className="px-6 py-4">
                                            <img src={team.logo} alt={team.logo} />
                                        </td>
                                        <td className="px-6 py-4">
                                            {team.group}
                                        </td>
                                        <td className="px-6 py-4">
                                            {team.Name}
                                        </td>
                                        <th scope="row" className="text-left uppercase px-6 py-4 font-medium  whitespace-nowrap">
                                            {team.id}
                                        </th>
                                    </tr>
                                )
                            })

                            }

                        </tbody>
                    </table>
                </div>


                <div className='flex md:w-2/3 flex-row md:flex-row  justify-center items-end flex-wrap space-y-2 '>

                    <div className=' cursor-pointer md:w-2/5 w-1/3 mx-2 border-2 p-3 text-center rounded-lg bg-yakam hover:bg-shasham text-shasham hover:text-chwaram '>

                        <h1 onClick={() => { setGrop(groupa()) }} className='  hidden md:block text-3xl  drop-shadow-lg'>A یارییەکانی گروپی</h1>
                        <h1 onClick={() => { setGrop(groupa()) }} className='  md:hidden text-3xl  drop-shadow-lg'>A  گروپی</h1>

                    </div>

                    <div className=' cursor-pointer md:w-2/5 w-1/3 mx-2 border-2 p-3 text-center rounded-lg bg-yakam hover:bg-shasham text-shasham hover:text-chwaram '>

                        <h1 onClick={() => { setGrop(groupb) }} className='  hidden md:block text-3xl  drop-shadow-lg'>B یارییەکانی گروپی</h1>
                        <h1 onClick={() => { setGrop(groupb) }} className='  md:hidden text-3xl  drop-shadow-lg'>B  گروپی</h1>

                    </div>


                    <div className=' cursor-pointer md:w-2/5 w-1/3 mx-2 border-2 p-3 text-center rounded-lg bg-yakam hover:bg-shasham text-shasham hover:text-chwaram '>

                        <h1 onClick={() => { setGrop(groupc) }} className='  hidden md:block text-3xl  drop-shadow-lg'>C یارییەکانی گروپی</h1>
                        <h1 onClick={() => { setGrop(groupc) }} className='  md:hidden text-3xl  drop-shadow-lg'>C  گروپی</h1>

                    </div>

                    <div className=' cursor-pointer md:w-2/5 w-1/3 mx-2 border-2 p-3 text-center rounded-lg bg-yakam hover:bg-shasham text-shasham hover:text-chwaram '>

                        <h1 onClick={() => { setGrop(groupd) }} className='  hidden md:block text-3xl  drop-shadow-lg'>D یارییەکانی گروپی</h1>
                        <h1 onClick={() => { setGrop(groupd) }} className='  md:hidden text-3xl  drop-shadow-lg'>D  گروپی</h1>

                    </div>

                    <div className=' cursor-pointer md:w-2/5 w-1/3 mx-2 border-2 p-3 text-center rounded-lg bg-yakam hover:bg-shasham text-shasham hover:text-chwaram '>

                        <h1 onClick={() => { setGrop(groupe) }} className='  hidden md:block text-3xl  drop-shadow-lg'>E یارییەکانی گروپی</h1>
                        <h1 onClick={() => { setGrop(groupe) }} className='  md:hidden text-3xl  drop-shadow-lg'>E  گروپی</h1>

                    </div>

                    <div className=' cursor-pointer md:w-2/5 w-1/3 mx-2 border-2 p-3 text-center rounded-lg bg-yakam hover:bg-shasham text-shasham hover:text-chwaram '>

                        <h1 onClick={() => { setGrop(groupf) }} className='  hidden md:block text-3xl  drop-shadow-lg'>F یارییەکانی گروپی</h1>
                        <h1 onClick={() => { setGrop(groupf) }} className='  md:hidden text-3xl  drop-shadow-lg'>F  گروپی</h1>

                    </div>

                    <div className=' cursor-pointer md:w-2/5 w-1/3 mx-2 border-2 p-3 text-center rounded-lg bg-yakam hover:bg-shasham text-shasham hover:text-chwaram '>

                        <h1 onClick={() => { setGrop(groupg) }} className='  hidden md:block text-3xl  drop-shadow-lg'>G یارییەکانی گروپی</h1>
                        <h1 onClick={() => { setGrop(groupg) }} className='  md:hidden text-3xl  drop-shadow-lg'>G  گروپی</h1>

                    </div>

                    <div className=' cursor-pointer md:w-2/5 w-1/3 mx-2 border-2 p-3 text-center rounded-lg bg-yakam hover:bg-shasham text-shasham hover:text-chwaram '>

                        <h1 onClick={() => { setGrop(grouph) }} className='  hidden md:block text-3xl  drop-shadow-lg'>H یارییەکانی گروپی</h1>
                        <h1 onClick={() => { setGrop(grouph) }} className='  md:hidden text-3xl  drop-shadow-lg'>H  گروپی</h1>

                    </div>



                    <div className='w-full md:hidden'>

                        {grop}
                    </div>


                    <div className='hidden p-1 justify-center  md:block w-full'>
                        {grop}
                    </div>
                </div>


            </div>
        </Mainlayout>
    )
}
